import { object, func, bool, string } from 'prop-types'
import { useState, useEffect, useMemo } from 'react'

import { Loading, MessageModal, TableCustom } from "../../common"
import { useLista } from '../../hooks/useLista'
import { ALERT_TYPE, ShowToastMessage } from '@laramie/ui';
import MultaModal from '../MultaModal'
//import { getTipoMultas, generateInitMulta } from './utils'
import { generateInitMulta } from './utils'
import DataTaggerModalRedux from '../DataTaggerModalRedux'
import { GetMeses } from '../../../utils/helpers'
import { useEntidad } from '../../hooks/useEntidad'
import {TIPS} from "../../../consts/tips";

const MultasGrid = (props) => {
    const [edit, setEdit] = useState({ mode: null, item: null, })
    const [tipoMultas, setTipoMultas] = useState({})
    const [unidadesValor, setUnidadesValor] = useState({})
    const [dataTaggerState, setDataTaggerState] = useState({})
    const [loading, setLoading] = useState(false)

    const [getLista] = useLista({
        listas: ['UnidadValor'],
        onLoaded: (listas, isSuccess, error) => {
          if (!isSuccess) ShowToastMessage(ALERT_TYPE.ALERT_ERROR, error)
          else {
            const newUnidadesValor = {}
            getLista('UnidadValor').forEach(item => newUnidadesValor[item.id] = item)
            setUnidadesValor(newUnidadesValor)
          }
        },
        memo: {
          key: 'UnidadValor',
          timeout: 0,
        },
    })

    // useEffect(() => {
    //     setLoading(true)

    //     getTipoMultas({
    //         onSuccess: (data) => {
    //             const newTipoMultas = {}
    //             data.forEach(x => newTipoMultas[x.id] = x)
    //             setTipoMultas(newTipoMultas)
    //         },
    //         onDone: setLoading(false),
    //     })
    // }, [])

    const [, getRowEntidad] = useEntidad({
        entidades: ['Tasa','SubTasa','TipoMulta'],
        onLoaded: (entidades, isSuccess, error) => {
            if (!isSuccess) {
                ShowToastMessage(ALERT_TYPE.ALERT_ERROR, error);
            }
        },
        memo: {
          key: 'Tasa_SubTasa_TipoMulta',
          timeout: 0
        }
    });

    const filteredData = useMemo(() => {
        return props.data.list.filter(x => x.state !== 'r')
    }, [JSON.stringify(props.data.list)])

    const onEditAccept = (item) => {
        props.onChange('Multa', item)

        setEdit({ mode: null, item: null })
    }

    const onEditCancel = () => {
        setEdit({ mode: null, item: null })
    }

    const avmr = {
        onAdd: () => {
            setEdit({ mode: 'new', item: generateInitMulta(props.data.idCuenta), })
        },
        onModify: (item) => {
            setEdit({ mode: 'edit', item: {...item, state: 'm'}, })
        },
        onView: (item) => {
            setEdit({ mode: 'view', item, })
        },
        onRemove: (item) => {
            setEdit({ mode: 'remove', item: {...item, state: 'r'}, })
        },
        onAdditionalInfo: ({ id }, disabled) => {
            setDataTaggerState({ id, disabled })
        }
    }

    const getDescTasa = (id) => {
        const row = getRowEntidad('Tasa', id);
        return (row) ? `${row.codigo} - ${row.descripcion}` : '';
    }
    const getDescSubTasa = (id) => {
        const row = getRowEntidad('SubTasa', id);
        return (row) ? `${row.codigo} - ${row.descripcion}` : '';
    }
    const getDescTipoMulta = (id) => {
        const row = getRowEntidad('TipoMulta', id);
        return (row) ? row.nombre : '';
    }

    const meses = GetMeses(false);
    const getPeriodoMes = (row) => {
        return (row) ? row.periodo + "-" + meses.find(f => f.key === row.mes).code : '';
    }

    return (
        <div>
            <Loading visible={loading} />

            <TableCustom
                className="TableCustomBase"
                data={filteredData}
                avmr={avmr}
                columns={[
                    { Header: 'Tipo de multa', accessor: 'idTipoMulta', Cell: (data) => getDescTipoMulta(data.value), width: '21%' },
                    { Header: 'Tasa', Cell: (data) => getDescTasa(data.value), accessor: 'idTasa', width: '21%' },
                    { Header: 'Sub tasa', Cell: (data) => getDescSubTasa(data.value), accessor: 'idSubTasa', width: '20%' },
                    { Header: 'Año-Mes', accessor: 'fecha', Cell: (props) => getPeriodoMes(props.row.original), width: '10%' },
                    { Header: 'Unidad', accessor: 'idUnidadValor', Cell: ({ value }) => unidadesValor[value]?.nombre ?? '', width: '10%' },
                    { Header: 'Valor', accessor: 'valor', width: '10%' },
                    { Header: 'Saldado', accessor: 'idCuentaPago', Cell: ({ value }) => (value) ? 'Sí' : 'No', width: '8%' },
                ]}
                disabled={ props.disabled }
                showFilterGlobal={false}
            />

            {edit.mode && edit.mode !== 'remove' && (
                <MultaModal
                    {...edit}
                    idTipoTributo={props.data.idTipoTributo}
                    onAccept={onEditAccept}
                    onCancel={onEditCancel}
                />
            )}

            {edit.mode === 'remove' && (
                <MessageModal
                    title={"Confirmación"}
                    message={"¿Está seguro de borrar el registro?"}
                    onDismiss={onEditCancel}
                    onConfirm={() => onEditAccept(edit.item)}
                />
            )}

            {dataTaggerState.id && (
                <DataTaggerModalRedux
                    title="Información adicional de multa"
                    tipName={TIPS.NAME.MODALS.INFORMACION_ADICIONAL_MULTA_MODAL}
                    processKey={props.processKey}
                    entidad="Multa"
                    idEntidad={dataTaggerState.id}
                    disabled={dataTaggerState.disabled}
                    onDismiss={() => setDataTaggerState({})}
                />
            )}
        </div>
    )
}

MultasGrid.propTypes = {
    processKey: string.isRequired,
    disabled: bool,
    data: object.isRequired,
    onChange: func.isRequired,
}
  
MultasGrid.defaultProps = {
    disabled: false,
}

export default MultasGrid
